import React, { useEffect, useState } from "react";
import { loginRequest, msalConfig } from '../authConfig';
import { callMsGraph } from '../graph';
import { useMsal } from '@azure/msal-react';


export const ProfileData = (props) => {
    const { instance, accounts } = useMsal();
    const currentAccount = accounts[0];
    const accessTokenRequest = {
        scopes: loginRequest.scopes,
        account: currentAccount,
      };
    const [graphData, setGraphData] = useState(null);

    useEffect(() => {
        if (currentAccount.tenantId === msalConfig.auth.tenantId) {
            instance.acquireTokenSilent(accessTokenRequest)
                 .then((response) => {
                });
                //return `Bearer ${accessTokenResponse.accessToken}`;
              
          };
      
        instance
            .acquireTokenSilent({
                ...loginRequest,
                account: accounts[0],
            })
            .then((response) => {
                callMsGraph(response.accessToken).then((response) => setGraphData(response));
            });
    }, []);

    return (
        <div id="profile-div">
            <p>
                <strong>First Name: </strong> {graphData?.givenName}
            </p>
            <p>
                <strong>Last Name: </strong> {graphData?.surname}
            </p>
            <p>
                <strong>Email: </strong> {graphData?.userPrincipalName}
            </p>
            <p>
                <strong>Id: </strong> {graphData?.id}
            </p>
        </div>
    );
};